import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cc-ivr-not-available',
  templateUrl: './ivr-not-available.component.html',
  styleUrls: ['./ivr-not-available.component.scss']
})
export class IvrNotAvailableComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
